import { GlobalButton } from '@/components';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';

import { usePreparePackageActions } from '../hooks';

import { Tags } from '../models';

interface PreparePackageActionsProps {
  rowData: Record<string, any>;
}

export const PreparePackageActions = ({
  rowData,
}: PreparePackageActionsProps) => {
  const { onMarkAsLost, onMarkAsPrepared, isTagging } =
    usePreparePackageActions();

  return (
    <div>
      <GlobalButton
        variant={GlobalButtonVariant.secondaryButton}
        disabled={isTagging || rowData.tags?.includes(Tags.LOST)}
        action={() => onMarkAsLost(rowData.id)}
      >
        Marcar como perdido
      </GlobalButton>
      <span className='mx-1'></span>
      <GlobalButton
        variant={GlobalButtonVariant.primaryButton}
        disabled={isTagging || rowData.tags?.includes(Tags.PREPARED)}
        action={() => onMarkAsPrepared(rowData.id)}
      >
        Marcar como preparado
      </GlobalButton>
    </div>
  );
};
